import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { getTheme as _getTheme_ } from "@/utils/theme";

export type Theme = "light" | "dark";

export const getCollapsed = createSelector((state: RootState) => state.global, (global) => global.collapsed);

export const getTheme = createSelector((state: RootState) => state.global, (global): Theme => {
    /**跟随系统 */
    if (global.themeType === "none") {
        const type = _getTheme_();
        if (type === "none") {
            return "dark";
        }

        return type;
    }

    return global.themeType;
});

export const getThemeType = createSelector((state: RootState) => state.global, (global) => global.themeType);

export const getSelectedKeys = createSelector((state: RootState) => state.global, (global) => global.selectedKeys);

export const getOpenKeys = createSelector((state: RootState) => state.global, (global) => global.openKeys);

export const getTags = createSelector((state: RootState) => state.global, (global) => global.tags);

export const getSystemConfig = createSelector((state: RootState) => state.global, (global) => global.systemConfig);

export const getLoginResult = createSelector((state: RootState) => state.user, (user) => user.loginResult);

export const getClient = createSelector((state: RootState) => state.mqtt, (mqtt) => mqtt.client);

export const getConnected = createSelector((state: RootState) => state.mqtt, (mqtt) => mqtt.connected);

export const getVideoReals = createSelector((state: RootState) => state.mqtt, (mqtt) => mqtt.videoReals);